module.exports = __webpack_public_path__ + "packs/media/images/Profile-ab0f2264f58342c2599183ea839d32bf.svg";